var config = {

  //开发
  // apiUrl: 'http://127.0.0.1:8075',
  // apiUrl2: 'https://cjrh.xmist.edu.cn/cjrh-api/pageoffice',
  // fileShowUrl: '',
  // fileUrl1: 'http://localhost:8075/upload/toJstUpload',
  // fileUrl2: 'http://localhost:8075/upload/toJstUpload2?callBackPath=https://appzb.fjcpc.edu.cn/xyoa-back/index.html'

  //正式
  apiUrl: 'https://cjrh.xmist.edu.cn/cjrh-api',
  apiUrl2: 'https://cjrh.xmist.edu.cn/cjrh-api/pageoffice',
  fileShowUrl: '',
  fileUrl1: "https://cjrh.xmist.edu.cn/cjrh-api/upload/toJstUpload",
  fileUrl2: 'https://cjrh.xmist.edu.cn/cjrh-api/upload/toJstUpload2?callBackPath=https://cjrh.xmist.edu.cn/cjrh-back/index.html'


  //测试
  //apiUrl: 'http://localhost:8075',
  //fileShowUrl: 'http://192.168.90.33/fjcpc/',
  //fileUrl2: 'http://localhost:8075/upload/toJstUpload2',

};

export default config;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 115